import React from 'react';
import PauseDialog from './PauseDialog';
import ResumeDialog from './ResumeDialog';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import DeleteSuccessDialog from './DeleteSuccessDialog';

const CollectionDialogs = ({ dialogs, handlers, canDeleteApplication = false }) => (
    <>
        <PauseDialog isOpen={dialogs.pause.open} onConfirm={handlers.pause} onDismiss={handlers.closePause} />
        {canDeleteApplication && (
            <>
                <ResumeDialog
                    isOpen={dialogs.resume.open}
                    onConfirm={handlers.resume}
                    onDelete={handlers.navigateToCancelConfirm}
                />
                <DeleteConfirmDialog
                    isOpen={dialogs.cancel.open}
                    onConfirm={handlers.delete}
                    onBack={handlers.navigateBackToResume}
                    error={dialogs.cancel.error}
                    isLoading={dialogs.cancel.loading}
                />
                <DeleteSuccessDialog isOpen={dialogs.deleted.open} onClose={handlers.finalClose} />
            </>
        )}
    </>
);

export default CollectionDialogs;
